// src/routes/PrivateRouteWrapper.tsx
import React, { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"

interface PrivateRouteProps {
    children: ReactNode
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
    const { isAuthenticated, isLoading } = useAuth0()

    // If Auth0 is still loading user info, show a spinner or placeholder
    if (isLoading) {
        return (
            <div className="flex flex-col justify-center items-center min-h-screen">
                <h2 className="text-xl font-semibold mb-4">Loading user session...</h2>
                {/* Simple loading spinner with Tailwind classes */}
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-blue-500"></div>
            </div>
        )
    }

    // If the user is not authenticated, redirect them to the login page
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    // Otherwise, render the requested private component
    return <>{children}</>
}
